import { Stack, Typography } from "@mui/material";
import { AddCredits } from "@pages/settings/subscription-settings/credits/add-credits";
import {
  DEFAULT_TEXT_FONT_SIZE,
  DEFAULT_TITLE_FONT_SIZE,
} from "@styles/common-styles";
import NoCreditIcon from "@assets/icons/new/no-credit.svg?react";
import { CREDITS_DISPLAY_NAME } from "@src/constants/credit-constants";
import { capitalizeFirstLetter } from "@utils/string-utils";
import { neutral } from "@flat-ui";

/**
 * The component to show when the user doesn't have any credits(tokens) and never had any.
 */
export function NoCredits(): JSX.Element {
  return (
    <Stack
      sx={{
        alignItems: "center",
        width: "100%",
        gap: "12px",
        paddingBottom: "32px",
        backgroundColor: neutral[50],
      }}
    >
      <NoCreditIcon />
      <Typography
        sx={{
          fontSize: DEFAULT_TITLE_FONT_SIZE,
          fontWeight: 600,
          lineHeight: "24px",
          color: neutral[600],
        }}
      >
        You don't have any {CREDITS_DISPLAY_NAME} yet.
      </Typography>
      <Stack
        sx={{
          alignItems: "center",
          gap: "32px",
        }}
      >
        <Typography
          sx={{
            fontSize: DEFAULT_TEXT_FONT_SIZE,
            color: neutral[600],
            textAlign: "center",
          }}
        >
          {capitalizeFirstLetter(CREDITS_DISPLAY_NAME)} allow you and your team
          to generate floor plans within your projects. You can add{" "}
          {CREDITS_DISPLAY_NAME} anytime to start using them.
        </Typography>
        <AddCredits />
      </Stack>
    </Stack>
  );
}
